// What an incoming (money-in) transaction turns out to be once classified.
export var IncomingKind;
(function (IncomingKind) {
    IncomingKind["Payback"] = "PAYBACK";
    IncomingKind["Income"] = "INCOME";
    IncomingKind["Transfer"] = "TRANSFER";
})(IncomingKind || (IncomingKind = {}));
//# sourceMappingURL=incoming-kind.enum.js.map